import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1%',
    },
    formTitles: {
      fontWeight: 'bolder',
    },
    paper: {
      padding: theme.spacing(3),
    },
  }),
);
